import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.push.js";
var __default__ = {
  name: "EditConfirm",
  data: function data() {
    return {
      subject: "",
      scheduled_for: "",
      isLoading: {
        status: true,
        message: ""
      },
      processMessage: false
    };
  },
  created: function created() {
    this.setData();
  },
  methods: {
    setData: function setData() {
      var _this = this;

      getData("messages/" + this.$route.params.id + "?with=content").then(function (data) {
        var jpIndex = data.items[0].content.findIndex(function (_ref) {
          var locale = _ref.locale;
          return locale === "ja-JP";
        });
        _this.subject = data.items[0].content[jpIndex].subject;
        _this.scheduled_for = moment(data.items[0].call_scheduled_for).format("YYYY年MM月DD日 HH:mm");
      }).catch(function (error) {
        console.log(error);
      }).then(function () {
        _this.isLoading.status = false;
      });
    },
    openEditor: function openEditor() {
      var _this2 = this;

      this.processMessage = "予約取り消し中…しばらくおまちください";
      deleteData("eraser/delete_message_reservation/" + this.$route.params.id).then(function () {
        _this2.processMessage = "取り消し完了。編集画面を開いています…";
        setTimeout(function () {
          _this2.$router.push({
            name: "messages.edit",
            params: {
              id: _this2.$route.params.id
            }
          });
        }, 1000);
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
};
import { deleteData, getData } from "@/services/axios";
import moment from "moment";
import LoadingMessage from "@/components/common/LoadingMessage.vue";
export default /*#__PURE__*/Object.assign(__default__, {
  setup: function setup(__props) {
    return {
      __sfc: true,
      LoadingMessage: LoadingMessage
    };
  }
});